/*------------------------------------*\
    MODULES
\*------------------------------------*/
import $ from "jquery";
import Player from '@vimeo/player';

/*------------------------------------*\
    PROFILE VIDEO AUTOPLAY
\*------------------------------------*/
class VimeoProfileVideo {
    constructor(passedElement) {
        let self = this;
        self.elem = passedElement;
        self.vid = self.elem.dataset.videoid;
    }

    init() {
        let self = this;

        self.elem.addEventListener('click', function() {
            self.playVideo();
        });
    }

    playVideo() {
        let self = this;
        let iframe = document.querySelector('iframe#vvid-'+ self.vid);
        let player = new Player(iframe);

        $('#video-tab').tab('show');
        document.getElementById('stallion-gallery').scrollIntoView({ block: 'start',  behavior: 'smooth' });
        player.play();
    }
}

export default VimeoProfileVideo;
